// @See org.springframework.http.MediaType.class
export const MediaType = {

   APPLICATION_CONTENT_TYPE: 'Content-Type',
   APPLICATION_ATOM_XML_VALUE: 'application/atom+xml',
   APPLICATION_FORM_URLENCODED_VALUE: 'application/x-www-form-urlencoded',
   APPLICATION_JSON_VALUE: 'application/json',
   APPLICATION_OCTET_STREAM_VALUE: 'application/octet-stream',
   APPLICATION_XHTML_XML_VALUE: 'application/xhtml+xml',
   APPLICATION_XML_VALUE: 'application/xml',
   IMAGE_GIF_VALUE: 'image/gif',
   IMAGE_JPEG_VALUE: 'image/jpeg',
   IMAGE_PNG_VALUE: 'image/png',
   MULTIPART_FORM_DATA_VALUE: 'multipart/form-data',
   TEXT_HTML_VALUE: 'text/html',
   TEXT_PLAIN_VALUE: 'text/plain',
   TEXT_XML_VALUE: 'text/xml',

}



// WEBPACK FOOTER //
// ./src/app/shared/constants/src/media.constants.ts